@let urls = urls$ | async;

@if (urls && urls.length > 0 && !noExpansionPanel() && (visible$ | async)) {
  <div class="clw-container map-control-button-container"
    [class.clw-container--is-active]="toolActive()"
    (keyup.escape)="toggle(true)">

    <button mat-flat-button
      class="map-control-button"
      [class.toggle-button--active]="toolActive()"
      [tmTooltip]="title$ | async"
      (click)="toggle()">
      <mat-icon svgIcon="components_coordinate_link_window"></mat-icon>
    </button>

    @if (toolActive()) {
      <div class="clw-wrapper">
        <ng-container>
          <mat-form-field appearance="outline" color="primary">
            <mat-label i18n="@@core.coordinate-link-window.select-layer">Select link to open</mat-label>
            <mat-select [formControl]="urlControl" tmAutoFocus>
              @for (url of urls; track url) {
                <mat-option [value]="url">
                  {{url.alias || url.url}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </ng-container>
      </div>
    }
  </div>
} @else if (urls && urls.length > 0 && (visible$ | async)) {
  <h4 class="clw-url-label" i18n="@@core.coordinate-link-window.select-layer">Select link to open</h4>

  <mat-selection-list
    class="clw-url-selection-list"
    [multiple]="false"
    [hideSingleSelectionIndicator]="true"
    (selectionChange)="urlControl.setValue($event.options[0]?.value ?? null)">
    @for (url of urls; track url) {
      <mat-list-option
        [value]="url"
        [selected]="urlControl.value === url">
        <span matListItemIcon>
          @if (urlControl.value === url) {
            <mat-icon svgIcon="check"></mat-icon>
          }
        </span>
        <span matListItemTitle>{{ url.alias || url.url }}</span>
      </mat-list-option>
    }
  </mat-selection-list>
}
